import React, { Component } from 'react'

import ProfilePage from './ProfilePage'
import RedirectToLogin from 'components/RedirectToLogin'
import { useEditProfile, useProfile } from '../../profile'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ProfileSummaryButton from './ProfileSummaryButton'
import { loadPublishedPosts, loadPublishedResponses } from 'state/actions/posts'
import { useProfileSearchAction } from './AsyncMyProfilePage'

const EditProfileButton = () => {
  const editProfile = useEditProfile()
  return (
    <ProfileSummaryButton
      handler={editProfile}
      name="profile.edit_button"
      enabled
    />
  )
}

const MyProfilePage = ({ onSearch }) => {

  const { profile, loading, error, isLoggedIn } = useProfile()
  if (!isLoggedIn) {
    return <RedirectToLogin />
  }

  return (
    <ProfilePage
      isMine={true}
      profile={profile}
      loading={loading}
      error={error}
      ProfileSummaryButton={EditProfileButton}

    />
  )
}


export default MyProfilePage